/* eslint-disable */
import axios from "axios";

/**
 * @typedef {Object} Config
 * @property {any} data
 * @property {Object} headers
 */

export class HTTPClient {
  /**
   * @private
   * @memberof HTTPClient
   */
  client = axios;
  headers = {};

  /**
   *
   * @param {string} baseURL
   */
  constructor(baseURL) {
    this.baseURL = baseURL;
  }

  /**
   * @memberof HTTPClient
   * @param {('get' | 'post' | 'put' | 'delete' | 'option' | 'patch')} method
   * @param {string} url
   * @param {Config} config
   *
   */
  request(method, url, config) {
    const fullUrl = `${this.baseURL}${url}`;

    const params = {
      method,
      url: fullUrl
    };

    if (config) {
      params.headers = { ...this.headers, ...config.headers }
      params.data = config.data
      params.responseType = config.responseType
      params.params = config.params
    } else {
      params.headers = { ...this.headers };
    }

    return this.client.request(params);
  }

  /**
   * @memberof HTTPClient
   * @param {string} key
   * @param {string} value
   *
   * @return {void}
   */
  setHeader(key, value) {
    this.headers[key] = value;
  }
}
